export const hipHipWhatsAppNumber = '+525568852832';
export const hipHipPhoneNumber = '+525511076084';
export const whatsAppSendMessageApi = 'https://api.whatsapp.com/send?phone=';
